import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { useFormik, Form, FormikProvider } from "formik";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getMentorName } from "../../core/service/mentor.service";
import { renewalPostDocUpload } from "../../core/service/renewalPostDoc.service";
// material
import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  RadioGroup,
  Radio,
  Typography,
  TextField,
  Stack,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Swal from "sweetalert2";
// components
import Page from "../../components/Page";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";

// ----------------------------------------------------------------------
// const ROLE_ADMIN = "admin";
// const ROLE_MENTOR = "mentor";
// const ROLE_STD = "std";

const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

export default function RenewalPostDoc() {
  const navigate = useNavigate();
  const { user: currentUser } = useSelector((state) => state.authReducer);
  const [checkYes, setCheckYes] = useState(false);
  const [checkNo, setCheckNo] = useState(false);
  const [mentorNameOption, setMentorNameOption] = useState([
    { value: "", label: "" },
  ]);
  const [renewalContractOption] = useState([
    {
      value: "second year contract",
      label: "Second Year Contract",
    },
    {
      value: "third  year contract",
      label: "Third Year Contract",
    },
    {
      value: "fourth year contract",
      label: "Fourth Year Contract",
    },
    {
      value: "fifth year contract",
      label: "Fifth Year Contract",
    },
    {
      value: "sixth year contract",
      label: "Sixth Year Contract",
    },
    { value: "seventh year contract", label: "Sevent Year Contract" },
    { value: "eighth year contract", label: "Eighth Year Contract" },
    { value: "ninth year contract", label: "Ninth Year Contract" },
    { value: "tenth year contract", label: "Tenth Year Contract" },
  ]);

  const getMentorNameAndEmail = async () => {
    const mentorName = await getMentorName();
    setMentorNameOption(mentorName);
  };

  useEffect(() => {
    getMentorNameAndEmail();
  }, []);

  const renewalFellowshipFormYes = Yup.object().shape({
    renew_postdoctoral: Yup.string().required("Is required"),
    start_newContract: Yup.string().nullable().required(`Date is required`),
    renew_your_Contract: Yup.string().required("Is required"),
    // additional_inform_note: Yup.string().required("Is required")
  });

  const renewalFellowshipFormNo = Yup.object().shape({
    renew_postdoctoral: Yup.string().required("Is required"),
    this_renewal_contract_will_be_the: Yup.string().required("Is required"),
    reason_for_not_renewing_the_contract: Yup.string().required("Is required"),
  });

  const formik = useFormik({
    initialValues: {
      renew_postdoctoral: "",
      start_newContract: "",
      renew_your_Contract: "",
      additional_inform_note: "",
      this_renewal_contract_will_be_the: "",
      reason_for_not_renewing_the_contract: "",
    },
    validationSchema: checkYes
      ? renewalFellowshipFormYes
      : renewalFellowshipFormNo,
    onSubmit: async (values) => {
      var formData = new FormData();
      for (const [key, value] of Object.entries(values)) {
        formData.append(key, value);
      }
      formData.append("user_id", currentUser.id);

      await renewalPostDocUpload(formData).then((e) => {
        return Swal.fire({
          icon: "success",
          title: "Successfully",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) =>
          navigate("/form-making/post_doc", { replace: true })
        );
      });
      await new Promise((r) => setTimeout(r, 500));
    },
  });

  const {
    errors,
    getFieldProps,
    handleChange,
    handleSubmit,
    isSubmitting,
    touched,
    setFieldValue,
    values,
  } = formik;

  return (
    <Page title="Renewal of Fellowship">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Renewal of Fellowship</Typography>
        </Box>
        <Typography variant="caption" sx={{ fontSize: 16 }}>
          (For a postdoc who has fulfilled the completion of the previous
          contract by producing a Tier 1 publication which "being accepted for
          published" or "published")
        </Typography>
        <Grid
          container
          direction="column"
          justifyContent="space-around"
          alignItems="center"
          spacing={3}
          sx={{ paddingTop: 3 }}
        >
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={3} sx={{ paddingTop: 3 }}>
                <Typography variant="subtitle2" gutterBottom component="span">
                  Would you like to renew the postdoctoral fellowship contract?
                  *
                </Typography>
                <RadioGroup {...getFieldProps("renew_postdoctoral")}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                          onChange={(e) => {
                            setCheckYes(e.target.checked);
                            setCheckNo(false);
                          }}
                        />
                      }
                      label="Yes, I would."
                    />
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                          onChange={(e) => {
                            setCheckNo(e.target.checked);
                            setCheckYes(false);
                          }}
                        />
                      }
                      label="No, I would not."
                    />
                  </Stack>
                  <span
                    style={{
                      color: "#FF4842",
                      lineHeight: 1.5,
                      fontSize: "0.75rem",
                      fontFamily: "sans-serif",
                      fontWeight: 400,
                      textAlign: "left",
                      marginTop: "3px",
                      marginRight: "14px",
                      marginBottom: 0,
                      marginLeft: "14px",
                    }}
                  >
                    {errors.renew_postdoctoral}
                  </span>
                </RadioGroup>

                {checkYes && (
                  <>
                    <FormControl fullWidth>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        component="span"
                      >
                        When do you want to start the new contract?*
                      </Typography>

                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="dd/MM/yyyy"
                          value={values.start_newContract}
                          fullWidth
                          onChange={(date) => {
                            if (isValidDate(date)) {
                              setFieldValue(
                                "start_newContract",
                                date.toISOString()
                              );
                            } else {
                              setFieldValue("start_newContract", date);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              {...getFieldProps("start_newContract")}
                              error={Boolean(
                                touched.start_newContract &&
                                  errors.start_newContract
                              )}
                              helperText={
                                touched.start_newContract &&
                                errors.start_newContract
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </FormControl>

                    <FormControl fullWidth>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        component="span"
                      >
                        Which mentor would you like to renew your contract with?
                      </Typography>
                      <TextField
                        name="renew_your_Contract"
                        select
                        value={values.renew_your_Contract}
                        onChange={(e) => handleChange(e)}
                        {...getFieldProps("renew_your_Contract")}
                        error={Boolean(
                          touched.renew_your_Contract &&
                            errors.renew_your_Contract
                        )}
                        helperText={
                          touched.renew_your_Contract &&
                          errors.renew_your_Contract
                        }
                      >
                        {mentorNameOption.map((item, index) => (
                          <MenuItem key={index} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        component="span"
                        sx={{ paddingTop: 3 }}
                      >
                        Additional inform / Note
                      </Typography>
                      <TextField
                        variant="outlined"
                        {...getFieldProps("additional_inform_note")}
                        error={Boolean(
                          touched.additional_inform_note &&
                            errors.additional_inform_note
                        )}
                        helperText={
                          touched.additional_inform_note &&
                          errors.additional_inform_note
                        }
                      />
                    </FormControl>
                  </>
                )}
                {checkNo && (
                  <>
                    <FormControl fullWidth>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        component="span"
                      >
                        This renewal contract will be the
                      </Typography>
                      <TextField
                        name="this_renewal_contract_will_be_the"
                        select
                        value={values.this_renewal_contract_will_be_the}
                        onChange={(e) => handleChange(e)}
                        {...getFieldProps("this_renewal_contract_will_be_the")}
                        error={Boolean(
                          touched.this_renewal_contract_will_be_the &&
                            errors.this_renewal_contract_will_be_the
                        )}
                        helperText={
                          touched.this_renewal_contract_will_be_the &&
                          errors.this_renewal_contract_will_be_the
                        }
                      >
                        {renewalContractOption.map((item, index) => (
                          <MenuItem key={index} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </TextField>

                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        component="span"
                        sx={{ paddingTop: 3 }}
                      >
                        What is the reason for not renewing the contract?
                      </Typography>
                      <TextField
                        variant="outlined"
                        {...getFieldProps(
                          "reason_for_not_renewing_the_contract"
                        )}
                        error={Boolean(
                          touched.reason_for_not_renewing_the_contract &&
                            errors.reason_for_not_renewing_the_contract
                        )}
                        helperText={
                          touched.reason_for_not_renewing_the_contract &&
                          errors.reason_for_not_renewing_the_contract
                        }
                      />
                    </FormControl>
                  </>
                )}

                <FormControl fullWidth></FormControl>

                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{ paddingTop: 3 }}
                >
                  <LoadingButton
                    size="large"
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                  >
                    Submit
                  </LoadingButton>
                </Grid>
              </Stack>
            </Form>
          </FormikProvider>
        </Grid>
      </Container>
    </Page>
  );
}
